<template>
  <div class="h-full w-full">
    <div class="my-10px flex items-center h-36px">
      <TableButtonGroup :list="btnList" v-model="btn" @btn-click="btnTabClick"></TableButtonGroup>
      <!-- <div class="flex flex-1 justify-end items-end" v-if="btn === '工作票'">
        <el-select
          v-model="metalBimSelectValue"
          class="mr-10px w-136px"
          @change="metalBimSelect"
          popper-class="visualization-select-popper"
        >
          <el-option
            v-for="item in metalBimOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div> -->
    </div>
    <work-ticket-list :type="metalBimSelectValue" :player="player" v-if="btn === '工作票'" />
    <operation-ticket-list :player="player" v-if="btn === '操作票'" />
  </div>
</template>

<script>
// import { MetalBIMApi } from '@wiz-api/huizhou2'
import { isJSONObj } from '../../../assets/js/scene/scene'

const TableButtonGroup = () => {
  return import('@/components/cockpit/TableButtonGroup')
}

// components
const WorkTicketList = () => {
  return import('./WorkTicketList')
}

const OperationTicketList = () => {
  return import('./OperationTicketList')
}

// const metalBIMApi = new MetalBIMApi()
export default {
  components: { TableButtonGroup, WorkTicketList, OperationTicketList },
  name: 'TwoWork',
  props: {
    player: {
      type: Object,
      default: () => {},
    },
  },
  WorkTicketListprops: {
    transferProps: {
      type: Object,
      defalut: () => {},
    },
    cloudRender: {
      type: Object,
      default: () => {},
    },
    customProps: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      metalBimSelectValue: '',
      metalBimOptions: [
        {
          label: '全部',
          value: '',
        },
        {
          label: '待提交',
          value: 'WaitCommit',
        },
        {
          label: '待审批',
          value: 'WaitApprove',
        },
        {
          label: '执行中',
          value: 'Executing',
        },
        {
          label: '已完成',
          value: 'Finished',
        },
        {
          label: '已作废',
          value: 'Cancel',
        },
        {
          label: '已归档',
          value: 'Archived',
        },
      ],
      btn: '工作票',
      btnList: ['工作票', '操作票'],
      keyword: '',
      color: '0,1,0,0.392157',
    }
  },
  watch: {
    transferProps: {
      handler(val) {
        // this.currentTableName = val.name
        // this.page.pageNo = 1
        // this.metalBimDetailVisbal = false
        // this.getTableData()
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    async metalBimSelect(val) {
      this.type = val
      // 取消当前table行高亮
      // this.$refs.tableRef.setCurrentRow()
      // 切换之后发请求获取新的table数据
      // await this.getTableData()
    },
    btnTabClick(val) {
      this.btn = val
      // this.cloudRender.Tool.setTool('system.ToolMultiSelect', false)
    },
    // 返回初始视角
    backInitPositon() {
      if (this.customProps?.sceneOptions?.jsonData) {
        const jsonData = JSON.parse(this.customProps.sceneOptions.jsonData)
        const cameraParams = jsonData.cameraParams
          ? JSON.parse(jsonData.cameraParams)
          : { eye: [-1028, 580, 13821], target: [-1028, 579, 85], up: [0, 1, 0] }
        this.cloudRender.Camera.moveCamera('CameraParam', cameraParams)
      }
    },
  },
  created() {},
  beforeDestroy() {
    this.backInitPositon()
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-loading-mask {
  background-color: #1e4960 !important;
  opacity: 1 !important;
}
</style>
